var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24327",
    "data-name": "Group 24327",
    transform: "translate(-1021 -1048)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12915",
    "data-name": "Rectangle 12915",
    width: 12,
    height: 12,
    transform: "translate(1021 1048)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_002-smartphone",
    "data-name": "002-smartphone",
    transform: "translate(972.31 1048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11973",
    "data-name": "Group 11973",
    transform: "translate(51.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M118.606,0h-3.738a1.175,1.175,0,0,0-1.176,1.154V9.913a1.164,1.164,0,0,0,1.164,1.152l3.744,0a1.156,1.156,0,0,0,1.155-1.152l.005-8.756A1.154,1.154,0,0,0,118.606,0ZM116.2.692h1.085a.173.173,0,1,1,0,.346H116.2a.173.173,0,1,1,0-.346Zm-.652.055a.179.179,0,0,1,.245,0,.173.173,0,0,1-.122.3.177.177,0,0,1-.123-.051.174.174,0,0,1,0-.245Zm1.159,9.976a.517.517,0,1,1,.517-.517A.518.518,0,0,1,116.7,10.723Zm2.521-1.386H114.3V1.643h4.927Z",
    transform: "translate(-113.692)",
    fill: "#00101a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.a76499b88ab8384aa7f9d77584a3c7b4.svg";
export { ForwardRef as ReactComponent };